<template>
  <v-app>

    <Loading :status="isLoading" 
             class="global-loading"
             :opacity="1"
             :linear="isLoading=='linear'"
             color="grey"
             :size="50"
             :width="2"/>

    <router-view/>

  </v-app>
</template>

<style type="text/css">
  #app.v-application {
    background: radial-gradient(circle, rgba(30,65,115,1) 35%, rgba(15,23,42,1) 100%);
  }
</style>

<script>
import utility from '@/mixins/utility'

import Loading from '@/components/UI/Loading'

import { mapGetters } from 'vuex'

export default {
  name: 'App',

  mixins: [ utility ],

  components: {
    Loading,
  },

  data: () => ({
    //
  }),

  computed:
  {
    ...mapGetters({
      isLoading: 'ui/isLoading'
    })
  },

  mounted()
  {

  },

  methods:
  {
    
  },

  watch:
  {
    $route()
    {
      //this.$vuetify.goTo(0)
    }
  }
};
</script>
